module.exports = __webpack_public_path__ + "media/assets/images/category/NewYear@2x-4d136d1ac526d4506c690fc0003db115.png";